"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'content-spoiler';
exports.cssAnchorName = cssAnchorName;

var ContentSpoiler = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ContentSpoiler, _Component);

  var _super = _createSuper(ContentSpoiler);

  function ContentSpoiler(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContentSpoiler);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showContent: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleSpoiler", function () {
      return _this.setState(function (state) {
        return {
          showContent: !state.showContent
        };
      }, function () {
        return _this.props.parentEl.classList.toggle('content-hidden');
      });
    });
    props.parentEl.className = 'spoiler-container content-hidden';
    return _this;
  }

  (0, _createClass2.default)(ContentSpoiler, [{
    key: "render",
    value: function render() {
      var showContent = this.state.showContent;
      return (0, _preact.h)("details", {
        className: "spoiler-container",
        open: showContent,
        onToggle: this.toggleSpoiler
      }, (0, _preact.h)("summary", {
        className: "spoiler-toggle-button"
      }, (0, _preact.h)("span", {
        className: "".concat(!showContent ? 'is-hidden' : '')
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: "bb.spoiler.hide-content"
      })), (0, _preact.h)("span", {
        className: "".concat(showContent ? 'is-hidden' : '')
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: "bb.spoiler.show-content"
      }))));
    }
  }]);
  return ContentSpoiler;
}(_preact.Component);

exports.default = ContentSpoiler;